import React from 'react'
import DotsSvg from 'images/modules/Manage/i-dots.svg?raw'

export { default as DotsUrl } from 'images/modules/Manage/i-dots.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: DotsSvg}} />
)
